import { useCallback } from 'react';

import { App_Visibility, AppInstance_Visibility, AppPreconditionStatus } from '../ai.h2o.cloud.appstore';
import AppListPage from '../components/AppListPage/AppListPage';
import { AdminAppService } from '../services/api';
import { useApp, useUser } from '../utils/hooks';

export default function AdminAppsPage() {
  const { isAdmin } = useUser();
  const { getAdminApps } = useApp();

  const fetchApps = useCallback(
    async () =>
      getAdminApps({
        limit: 1000,
        offset: 0,
        visibility: App_Visibility.VISIBILITY_UNSPECIFIED,
        allUsers: true,
        name: '',
        latestVersions: false,
        withPreference: false,
        tags: [],
        conditionsStatus: AppPreconditionStatus.STATUS_UNSPECIFIED,
        visibilities: [],
      }),
    []
  );

  const fetchInstances = useCallback(async () => {
    const result = await AdminAppService.listAppInstances({
      appId: '',
      includeAppDetails: true,
      visibility: AppInstance_Visibility.VISIBILITY_UNSPECIFIED,
      allUsers: true,
      allWorkspaces: false,
      parent: '',
    });
    return result.instances;
  }, []);

  return <AppListPage title="Admin Apps" fetchApps={fetchApps} fetchInstances={fetchInstances} isAdmin={isAdmin} />;
}
